import { ResourceTypeEnum } from '@/types/schema';

import { Content } from '../types';

export const CONTENT_TYPE_CAN_USE_PROGRESS = [
  ResourceTypeEnum.Article,
  ResourceTypeEnum.Course,
  ResourceTypeEnum.ExternalContent,
  ResourceTypeEnum.Scorm,
  ResourceTypeEnum.LiveEventContent,
  ResourceTypeEnum.OfflineEventContent,
  ResourceTypeEnum.ExternalEventContent,
];

export const getContentProgress = (content: Content) => {
  if (content.type && CONTENT_TYPE_CAN_USE_PROGRESS.includes(content.type)) {
    return { progress: content.performance?.progress as number };
  }

  const duration = content.duration;

  if (!duration) {
    return { progress: 0 };
  }

  const estimatedTimeSpent = content.performance?.estimatedTimeSpent || 0;

  return { progress: Math.floor((estimatedTimeSpent / duration) * 100) };
};
